import type { RNVJNavigationEventV2 } from "@indeed/signals-schema/com/indeed/signals/schema/viewjob/RNVJHttpErrorV2";

import {
  type RNVJNavigationTrigger,
  toSignalsRNVJNavigationTrigger,
} from "../types/RNVJNavigationTrigger";

export default function getRNVJNavigationEvent(
  url: string,
  trigger: RNVJNavigationTrigger | null | undefined,
  source: string | null | undefined,
): RNVJNavigationEventV2 {
  return {
    url,
    trigger: toSignalsRNVJNavigationTrigger(trigger),
    from: source ?? "",
  };
}
